import endpoints from '@/constants/endpoints';
import axiosV2 from '../axiosv2';
import { KamListResponse } from '../model/staff/StaffDto';

export async function getKamList() {
  const endpoint = endpoints.staff.kamList;

  const response = await axiosV2.get<KamListResponse>(endpoint, {
    params: {
      limit: 50,
    },
  });

  return response;
}
